import SubsectionCard from "../../WritingGradeSection/SubsectionCard";

const TaskFulfillmentSection = ({ taskFulfillment }) => {
  const developingAManagementPlan =
    taskFulfillment["developing_a_management_plan"];
  const elicitingRelevantHistoryAndImpact =
    taskFulfillment["eliciting_relevant_history_and_impact"];
  const explainingConditionAndExpectations =
    taskFulfillment["explaining_condition_and_expectations"];
  const identifyingAndExplainingContributingFactors =
    taskFulfillment["identifying_and_explaining_contributing_factors"];
  const proposingEvidenceBasedInterventions =
    taskFulfillment["proposing_evidence_based_interventions"];

  return (
    <div className="writingGradeSectionContainer">
      <div className="writingGradeSectionHeaderContainer">
        <h2 className="writingGradeSectionHeader">
          Task Fulfillment - Score {taskFulfillment.total}/50
        </h2>
      </div>
      <div className="writingGradeSectionBodyContainer">
        <div className="writingGradeSectionSubsectionWrapper">
          <SubsectionCard
            title={"Developing a Management Plan"}
            score={`${developingAManagementPlan.score}/10`}
            subTitle={"Comments"}
            subContent={developingAManagementPlan.comments}
          />
          <SubsectionCard
            title={"Eliciting Relevant History and Impact"}
            score={`${elicitingRelevantHistoryAndImpact.score}/10`}
            subTitle={"Comments"}
            subContent={elicitingRelevantHistoryAndImpact.comments}
          />
          <SubsectionCard
            title={"Explaining Condition and Expectations"}
            score={`${explainingConditionAndExpectations.score}/10`}
            subTitle={"Comments"}
            subContent={explainingConditionAndExpectations.comments}
          />
          <SubsectionCard
            title={"Identifying and Explaining Contributing Factors"}
            score={`${identifyingAndExplainingContributingFactors.score}/10`}
            subTitle={"Comments"}
            subContent={identifyingAndExplainingContributingFactors.comments}
          />
          <SubsectionCard
            title={"Proposing Evidence-Based Interventions"}
            score={`${proposingEvidenceBasedInterventions.score}/10`}
            subTitle={"Comments"}
            subContent={proposingEvidenceBasedInterventions.comments}
          />
        </div>
        <div className="writingGradeSectionScoreText">
          Score: {taskFulfillment.total}/50
        </div>
      </div>
    </div>
  );
};

export default TaskFulfillmentSection;
